import {Injectable} from "@angular/core";

@Injectable()
export class UserProfileConfig {
  userProfileUrl?: string;
  name?: string;
}
